/** Auto-renewable subscription Terms of Use (EULA) — required on purchase screens and App Store metadata. */
export const SUBSCRIPTION_TERMS_OF_USE_PDF_PATH = '/SMSP-Subscriptions-Pricing.pdf';

export const SUBSCRIPTION_TERMS_OF_USE_LABEL = 'Terms of Use (EULA)';
